import Vue from 'vue'
import Router from 'vue-router'
import process from "process";

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login/index')
  },
  {
    path: '/home',
    name: 'home',
    meta: {title: "全量统计"},
    redirect: "/webInfo",
    component: () => import('../views/layout/Layout'),
    children: [
      {
        path: '/webInfo',
        name: 'webInfo',
        component: () => import('../views/home/index')
      },
      {
        path:'/dashboard',
        name: 'dashboard',
        component: () => import('../views/home/dashboard')
      },
      {
        path:'/catStatics',
        name: 'catStatics',
        component: () => import('../views/home/catStatics')
      },
      {
        path:'/everyCat',
        name: 'everyCat',
        component: () => import('../views/home/everyCat')
      },
      {
        path:'/produceStatic',
        name: 'produceStatic',
        component: () => import('../views/home/produceStatic')
      }
    ]
  },
  {
    path: "/shop",
    name: "shop",
    meta: {title: "店铺管理"},
    redirect: "/shopList",
    component: () => import('../views/layout/Layout'),
    children: [
      {
        meta: {title: "店铺列表"},
        path: '/shopList',
        name: 'shopList',
        component: () => import('../views/shop/shopList')
      },
      {
        meta: {title: "员工列表"},
        path: '/empList',
        name: 'empList',
        component: () => import('../views/shop/empList')
      },
      {
        meta: {title: "角色列表"},
        path: '/roleList',
        name: 'roleList',
        component: () => import('../views/shop/roleList')
      },
      {
        meta: {title: "笼位管理"},
        path: '/cageMange',
        name: 'cageMange',
        component: () => import('../views/shop/cageMange')
      },
      {
        meta: {title: "出仓统计"},
        path: '/warehouse',
        name: 'warehouse',
        component: () => import('../views/shop/warehouse')
      }
    ]
  },
  {
    path: "/cat",
    name: "cat",
    meta: {title: "宠物信息"},
    redirect: "/catList",
    component: () => import('../views/layout/Layout'),
    children: [
      {
        meta: {title: "宠物档案"},
        path: '/catList',
        name: 'catList',
        component: () => import('../views/cat/catList')
      },{
        meta: {title: "品种颜色"},
        path: '/varietyColor',
        name: 'varietyColor',
        component: () => import('../views/cat/varietyColor')
      },{
        meta: {title: "严选医院"},
        path: '/hospitalList',
        name: 'hospitalList',
        component: () => import('../views/cat/hospitalList')
      },
      {
        meta: {title: "宠物病例"},
        path: '/catCase',
        name: 'catCase',
        component: () => import('../views/cat/catCase')
      },
      {
        meta: {title: "采购单"},
        path: '/purchase',
        name: 'purchase',
        component: () => import('../views/cat/Purchase')
      },{
        meta: {title: "采购运输"},
        path: '/purchaseCatList',
        name: 'purchaseCatList',
        component: () => import('../views/cat/purchaseCatList')
      },
    ]
  },
  {
    path: "/goods",
    name: "goods",
    meta: {title: "商品管理"},
    redirect: "/goodsList",
    component: () => import('../views/layout/Layout'),
    children: [
      {
        meta: {title: "商品列表"},
        path: '/goodsList',
        name: 'goodsList',
        component: () => import('../views/goods/goodsList')
      },
      {
        meta: {title: "商品添加"},
        path: '/addGoods',
        name: 'addGoods',
        component: () => import('../views/goods/addGoods/addGoods')
      },
      {
        meta: {title: "商品类别"},
        path: '/goodsCategory',
        name: 'goodsCategory',
        component: () => import('../views/goods/categoryList')
      },
      {
        meta: {title: "素材中心"},
        path: '/material',
        name: 'material',
        component: () => import('../views/goods/material')
      },
      {
        meta: {title: "品牌管理"},
        path: '/brandsMange',
        name: 'brandsMange',
        component: () => import('../views/goods/brandsMange')
      }
    ]
  },
  {
    path: "/order",
    name: "order",
    meta: {title: "订单中心"},
    redirect: "/orderHome",
    component: () => import('../views/layout/Layout'),
    children: [
      {
        meta: {title: "猫咪订单"},
        path: '/orderCat',
        name: 'orderCat',
        component: () => import('../views/order/orderCat')
      },
      {
        meta: {title: "采购订单"},
        path: '/orderDeliver',
        name: 'orderDeliver',
        component: () => import('../views/order/orderDeliver')
      },
      {
        meta: {title: "采购售后"},
        path: '/orderdeliverAfterSales',
        name: 'orderdeliverAfterSales',
        component: () => import('../views/order/orderdeliverAfterSales')
      },
      {
        meta: {title: "商城订单"},
        path: '/orderHome',
        name: 'orderHome',
        component: () => import('../views/order/orderHome')
      },
      {
        meta: {title: "售后订单"},
        path: '/orderAfterSaleHome',
        name: 'orderAfterSaleHome',
        component: () => import('../views/order/orderAfterSaleHome')
      },
      {
        meta: {title: "订单详情"},
        path: '/orderDetail',
        name: 'orderDetail',
        component: () => import('../views/order/orderDetail')
      },
      {
        meta: {title: "批量发货"},
        path: '/batchSendGoods',
        name: 'batchSendGoods',
        component: () => import('../views/order/batchSendGoods')
      },
    ]
  },
  {
    path: "/user",
    name: "user",
    meta: {title: "用户管理"},
    redirect: "/userList",
    component: () => import('../views/layout/Layout'),
    children: [
      {
        meta: {title: "用户列表"},
        path: '/userList',
        name: 'userList',
        component: () => import('../views/user/userList')
      },
      {
        meta: {title: "核销人员"},
        path: '/writeOffUserList',
        name: 'writeOffUserList',
        component: () => import('../views/setting/writeOffUserList')
      },
      {
        meta: {title: "会员列表"},
        path: '/memberLevelList',
        name: 'memberLevelList',
        component: () => import('../views/user/memberLevelList')
      },
      {
        meta: {title: "用户意见"},
        path: '/userOpinionList',
        name: 'userOpinionList',
        component: () => import('../views/user/userOpinionList')
      },
      {
        meta: {title: "客诉及回访"},
        path: '/customerComplaints',
        name: 'customerComplaints',
        component: () => import('../views/user/customerComplaints')
      }
      
    ]
  },
  {
    path: "/setting",
    name: "setting",
    meta: {title: "商城设置"},
    redirect: "/baseSetting",
    component: () => import('../views/layout/Layout'),
    children: [
      {
        meta: {title: "小程序设置"},
        path: '/baseSetting',
        name: 'catList',
        component: () => import('../views/setting/baseSetting')
      },
      {
        meta: {title: "后台设置"},
        path: '/systemSetting',
        name: 'systemSetting',
        component: () => import('../views/setting/systemSetting')
      },
      {
        meta: {title: "订单设置"},
        path: '/orderSetting',
        name: 'orderSetting',
        component: () => import('../views/setting/orderSetting')
      },
      {
        meta: {title: "运费设置"},
        path: '/freightSetting',
        name: 'freightSetting',
        component: () => import('../views/setting/freightSetting')
      },
      {
        meta: {title: "添加运费规则"},
        path: '/addFreight',
        name: 'addFreight',
        component: () => import('../views/setting/addFreight')
      },
      {
        meta: {title: "添加包邮规则"},
        path: '/addFree',
        name: 'addFree',
        component: () => import('../views/setting/addFree')
      },
    ]
  },
  {
    path: "/preferential",
    name: "preferential",
    meta: {title: "营销中心"},
    redirect: "/cardCouponList",
    component: () => import('../views/layout/Layout'),
    children: [
      {
        meta: {title: "卡券列表"},
        path: '/cardCouponList',
        name: 'cardCouponList',
        component: () => import('../views/preferential/cardCouponList')
      },
      {
        meta: {title: "优惠券列表"},
        path: '/couponList',
        name: 'couponList',
        component: () => import('../views/preferential/couponList')
      },
      {
        meta: {title: "优惠券统计"},
        path: '/couponStatistic',
        name: 'couponStatistic',
        component: () => import('../views/preferential/couponStatistic')
      },
      {
        meta: {title: "卡券统计"},
        path: '/CardCouponStatistic',
        name: 'CardCouponStatistic',
        component: () => import('../views/preferential/CardCouponStatistic')
      },
      {
        meta: {title: "礼品卡统计"},
        path: '/giftCardStatistic',
        name: 'giftCardStatistic',
        component: () => import('../views/preferential/giftCardStatistic')
      }
    ]
  },
  {
    path: "/sesame",
    name: "sesameList",
    meta: {title: "芝麻分"},
    redirect: "/sesameList",
    component: () => import('../views/layout/Layout'),
    children: [
      {
        meta: {title: "商城订单"},
        path: '/sesameList',
        name: 'sesameList',
        component: () => import('../views/sesame/sesameList')
      },
      {
        meta: {title: "充值记录"},
        path: '/inMoneyRecord',
        name: 'inMoneyRecord',
        component: () => import('../views/sesame/inMoneyRecord')
      }
    ]
  },
  {
    path: "/message",
    name: "message",
    meta: {title: "消息通知"},
    redirect: "/messageList",
    component: () => import('../views/layout/Layout'),
    children: [
      {
        meta: {title: "消息通知列表"},
        path: '/messageList',
        name: 'messageList',
        component: () => import('../views/message/messageList')
      }
    ]
  },
  {
    path: "/workPlatform",
    name: "workPlatform",
    meta: {title: "工作台"},
    redirect: "/approval",
    component: () => import('../views/layout/Layout'),
    children: [
      {
        meta: {title: "OA审批"},
        path: '/approval',
        name: 'approval',
        component: () => import('../views/workPlatform/approval')
      },
      {
        meta: {title: "线上签约"},
        path: '/signOnline',
        name: 'signOnline',
        component: () => import('../views/workPlatform/signOnline')
      },
      {
        meta: {title: "合同管理"},
        path: '/contract',
        name: 'contract',
        component: () => import('../views/workPlatform/contract')
      },
      {
        meta: {title: "操作日志"},
        path: '/eventLog',
        name: 'eventLog',
        component: () => import('../views/workPlatform/eventLog')
      }
    ]
  },
  {
    path: "/feedersMange",
    name: "feedersMange",
    meta: {title: "养户管理"},
    redirect: "/feedersMange",
    component: () => import('../views/layout/Layout'),
    children: [
     
      {
        meta: {title: "养户列表"},
        path: '/feedersList',
        name: 'feedersList',
        component: () => import('../views/feedersMange/feedersList')
      }
    ]
  },
  {
    path: "/退款中心",
    name: "refundMange",
    meta: {title: "退款中心"},
    redirect: "/refundMange",
    component: () => import('../views/layout/Layout'),
    children: [
     
      {
        meta: {title: "退款列表"},
        path: '/refundList',
        name: 'refundList',
        component: () => import('../views/refundMange/refundList')
      }
    ]
  },
];

const router = new Router({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
//to到哪儿  from从哪儿离开  next跳转 为空就是放行
  if (to.path === '/login' || to.path === '/') {
    //如果跳转为登录，就放行
    next();
  } else {
    // 取出localStorage判断
    let token = localStorage.getItem('token');
    if (token == null || token === '') {
      next({name: ''});
    } else {
      next();
    }
    next();
  }});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js